/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authresolvefailedsupport3Inputs */



/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Authresolvefailedsupport3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const authresolvefailedsupport3 = /** @type {((inputs?: Authresolvefailedsupport3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authresolvefailedsupport3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Contact support")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escribir a soporte")
	return /** @type {LocalizedString} */ ("Написать в поддержку")
});
export { authresolvefailedsupport3 as "authResolveFailedSupport" }